import Company from './Company';

export default Company;


// WEBPACK FOOTER //
// /src/components/intro/pages/about/company/index.js